import React from "react";
import { Button } from '@mui/material';
import { useRouter } from "next/router";
import Link from "next/link"; 
import { dataConstants } from "../../constants";

export default function LoginMenu() {
  const router = useRouter();
  
  return (
    <Button
      component={Link}
      href={{ pathname: '/auth', query: { from: router?.asPath } }}
      sx={{ 
        my: 1, 
        ml: 2, 
        color: "#fff", 
        fontWeight: 600, 
        fontSize: '0.875rem', 
        display: { xs: "none", lg: "flex" }, 
        textTransform: 'none',
        borderRadius: '8px',
        px: 3,
        border: '1px solid rgba(255, 255, 255, 0.3)',
        transition: 'all 0.2s ease',
        '&:hover': { 
          bgcolor: 'rgba(255, 255, 255, 0.1)', 
          border: '1px solid rgba(255, 255, 255, 0.5)' 
        } 
      }}
      aria-label="Sign In"
    >
      {dataConstants.SIGNIN || "Sign In"}
    </Button>
  );
}